import { forwardRef } from 'react';

import { PoweredByGoogleIcon } from '@anyx/shared-icons';

export const InputPostalCodeFooter = forwardRef<HTMLDivElement, unknown>((_, ref) => (
  <div ref={ref} className="pointer-events-none flex justify-end border-t px-2">
    <PoweredByGoogleIcon className="w-28" />
  </div>
));
